<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col cols="6" class="text-center text-sm-left mb-4 mb-sm-0 ui-title-text">
        <span class="text-uppercase page-subtitle">Strona główna</span>
        <h3 class="page-title">Witaj w panelu</h3>
      </d-col>

      <d-col cols="6" class="text-right ui-title-buttons">
        <d-button
          theme="primary"
          class="mt-3"
          @click.prevent="loadData"
          :disabled="!loaded">
          <template v-if="loaded">
            <i class="material-icons">refresh</i>
            <span class="ui-button-label">Odśwież</span>
          </template>
          <template v-if="!loaded">
            <div
              class="spinner-border spinner-border-sm"
              role="status"></div>
          </template>
        </d-button>

        <d-button
          theme="danger"
          class="mt-3 ml-3"
          @click.prevent="$router.push('/wyloguj')">
          <i class="material-icons">logout</i>
          <span class="ui-button-label">Wyloguj</span>
        </d-button>
      </d-col>
    </d-row>

    <d-row v-if="!loaded">
      <d-alert
        show
        theme="light"
        class="text-center w-100">
        Trwa wczytywanie danych...
      </d-alert>
    </d-row>

    <d-row
      v-if="loaded"
      class="text-center">
      <d-button-group class="ml-auto mr-auto mt-3">
        <d-button
          :outline="showToday"
          @click.prevent="showToday = false; loadData();">
          Wszystkie zadania
        </d-button>
        <d-button
          :outline="!showToday"
          @click.prevent="showToday = true; loadData();">
          Tylko dzisiejsze
        </d-button>
      </d-button-group>
    </d-row>

    <template v-if="loaded">
      <h4 class="mt-4 mb-4">
        Do dostarczenia
        <d-badge :theme="deliveryItemsCount > 0 ? 'primary' : 'secondary'">
          {{ deliveryItemsCount }}
        </d-badge>
      </h4>

      <d-card
        v-if="!!deliveryItemsCount"
        class="p-0 is-visible-on-desktop">
        <d-card-body class="p-0">
          <table class="table mb-0">
            <thead class="bg-light">
              <tr>
                <td style="width: 140px;">Data dostawy</td>
                <td>Odbiorca</td>
                <td style="width: 240px;">Adres dostawy</td>
                <td style="width: 200px;">Produkt</td>
                <td style="width: 140px;">Do dostarczenia</td>
                <td style="width: 180px;">Akcje</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) of deliveryItems"
                :key="'delivery-item-' + index">
                <td>{{ item.planned_delivery_date }}</td>
                <td>
                  {{ item.worker.name }}<br>
                  <small>
                    Dotyczy zamówienia: <br>
                    <span class="text-primary">
                      {{ item.order.order_name }} (#{{ item.order.id }})
                    </span>
                  </small>
                </td>
                <td>
                  <a
                    v-if="item.worker.remote_job_address"
                    :href="'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(item.worker.remote_job_address)"
                    target="_blank">
                    <i class="material-icons">near_me</i>
                    {{ item.worker.remote_job_address }}
                  </a>
                  <br v-if="item.worker.remote_job_address && item.worker.phone">
                  <br v-if="item.worker.remote_job_address && item.worker.phone">
                  <template v-if="item.worker.phone">
                    <a :href="'tel:' + item.worker.phone.replace(/[^0-9]/mis, '')">
                      <i class="material-icons">call</i>
                      {{ item.worker.phone }}
                    </a>
                  </template>
                </td>
                <td>
                  {{ item.order_product.name }}<br>
                  <small>
                    <template v-if="item.order_product.color_name">
                      Kolor: {{ item.order_product.color_name }}<br>
                    </template>
                    <template v-if="item.order_product.material_name">
                      Materiał: {{ item.order_product.material_name }}<br>
                    </template>
                    <template v-if="item.order_product.size_name">
                      Rozmiar: {{ item.order_product.size_name }}
                    </template>
                  </small>
                </td>
                <td>
                  {{ item.quantity_to_execution }} szt.
                </td>
                <td>
                  <d-button
                    theme="success"
                    :disabled="!!deliverySaveInProgress"
                    class="w-100"
                    @click.prevent="saveDelivery(item.id)">
                    <div
                      v-if="deliverySaveInProgress === item.id"
                      class="spinner-border spinner-border-sm"
                      role="status"></div>
                    Dostarczono
                  </d-button>
                </td>
              </tr>
            </tbody>
          </table>
        </d-card-body>
      </d-card>

      <d-card
        v-for="(item, index) of deliveryItems"
        :key="'delivery-mobile-item-' + index"
        class="is-visible-on-mobile p-3 mb-3">
        <div>
          Data dostawy: <span class="text-primary">{{ item.planned_delivery_date }}</span>
        </div>
        <div class="my-2">
          Odbiorca: <span class="text-primary">{{ item.worker.name }}</span><br>
          <small>
            Dotyczy zamówienia: <br>
            <span class="text-primary">
              {{ item.order.order_name }} (#{{ item.order.id }})
            </span>
          </small>
        </div>
        <div class="my-2">
          <a
            v-if="item.worker.remote_job_address"
            :href="'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(item.worker.remote_job_address)"
            target="_blank">
            <i class="material-icons">near_me</i>
            {{ item.worker.remote_job_address }}
          </a>
          <br v-if="item.worker.remote_job_address && item.worker.phone">
          <br v-if="item.worker.remote_job_address && item.worker.phone">
          <template v-if="item.worker.phone">
            <a :href="'tel:' + item.worker.phone.replace(/[^0-9]/mis, '')">
              <i class="material-icons">call</i>
              {{ item.worker.phone }}
            </a>
          </template>
        </div>
        <div class="my-2">
          {{ item.order_product.name }}<br>
          <small>
            <template v-if="item.order_product.color_name">
              Kolor: {{ item.order_product.color_name }}<br>
            </template>
            <template v-if="item.order_product.material_name">
              Materiał: {{ item.order_product.material_name }}<br>
            </template>
            <template v-if="item.order_product.size_name">
              Rozmiar: {{ item.order_product.size_name }}
            </template>
          </small>
        </div>
        <div class="mb-3">
          Do dostarczenia: {{ item.quantity_to_execution }} szt.
        </div>
        <div>
          <d-button
            theme="success"
            :disabled="!!deliverySaveInProgress"
            class="w-100"
            @click.prevent="saveDelivery(item.id)">
            <div
              v-if="deliverySaveInProgress === item.id"
              class="spinner-border spinner-border-sm"
              role="status"></div>
            Dostarczono
          </d-button>
        </div>
      </d-card>

      <d-alert
        theme="warning"
        :show="!deliveryItemsCount"
        class="text-center">
        Brak zadań do dostarczenia...
      </d-alert>

      <h4 class="mt-5 mb-4">
        Do odbioru
        <d-badge :theme="collectionItemsCount > 0 ? 'primary' : 'secondary'">
          {{ collectionItemsCount }}
        </d-badge>
      </h4>

      <d-card
        v-if="!!collectionItemsCount"
        class="p-0 is-visible-on-desktop">
        <d-card-body class="p-0">
          <table class="table mb-0">
            <thead class="bg-light">
              <tr>
                <td style="width: 140px;">Data odbioru</td>
                <td>Wykonawca</td>
                <td style="width: 240px;">Adres odbioru</td>
                <td style="width: 200px;">Produkt</td>
                <td style="width: 140px;">Odebrano</td>
                <td style="width: 180px;">Akcje</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) of collectionItems"
                :key="'collection-item-' + index"
                :class="{ 'is-ready': item.order_process_item.quantity_done === item.order_process_item.quantity }">
                <td>{{ item.planned_collection_date }}</td>
                <td>
                  {{ item.worker.name }}<br>
                  <small>
                    Dotyczy zamówienia: <br>
                    <span class="text-primary">
                      {{ item.order.order_name }} (#{{ item.order.id }})
                    </span>
                  </small><br>
                  <d-badge
                    v-if="item.order_process_item.quantity_done === item.order_process_item.quantity"
                    theme="success"
                    class="mt-2">
                    Gotowe do odbioru
                  </d-badge>
                  <d-badge
                    v-else
                    theme="warning"
                    class="mt-2">
                    Praca w toku
                  </d-badge>
                </td>
                <td>
                  <a
                    v-if="item.worker.remote_job_address"
                    :href="'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(item.worker.remote_job_address)"
                    target="_blank">
                    <i class="material-icons">near_me</i>
                    {{ item.worker.remote_job_address }}
                  </a>
                  <br v-if="item.worker.remote_job_address && item.worker.phone">
                  <br v-if="item.worker.remote_job_address && item.worker.phone">
                  <template v-if="item.worker.phone">
                    <a :href="'tel:' + item.worker.phone.replace(/[^0-9]/mis, '')">
                      <i class="material-icons">call</i>
                      {{ item.worker.phone }}
                    </a>
                  </template>
                </td>
                <td>
                  {{ item.order_product.name }}<br>
                  <small>
                    <template v-if="item.order_product.color_name">
                      Kolor: {{ item.order_product.color_name }}<br>
                    </template>
                    <template v-if="item.order_product.material_name">
                      Materiał: {{ item.order_product.material_name }}<br>
                    </template>
                    <template v-if="item.order_product.size_name">
                      Rozmiar: {{ item.order_product.size_name }}
                    </template>
                  </small>
                </td>
                <td>
                  {{ item.quantity_collected }} z {{ item.quantity_to_execution }} szt.
                </td>
                <td>
                  <d-button
                    theme="warning"
                    :disabled="!!collectionPartialSaveInProgress"
                    class="mb-3 w-100"
                    @click.prevent="openPopup(item)">
                    <div
                      v-if="collectionPartialSaveInProgress === item.id"
                      class="spinner-border spinner-border-sm"
                      role="status"></div>
                    Odbiór częściowy
                  </d-button>

                  <br>

                  <d-button
                    theme="success"
                    :disabled="!!collectionSaveInProgress"
                    class="w-100"
                    @click.prevent="saveFullCollection(item.id, item.quantity_to_execution)">
                    <div
                      v-if="collectionSaveInProgress === item.id"
                      class="spinner-border spinner-border-sm"
                      role="status"></div>
                    Odebrano wszystko
                  </d-button>
                </td>
              </tr>
            </tbody>
          </table>
        </d-card-body>
      </d-card>

      <d-card
        v-for="(item, index) of collectionItems"
        :key="'collection-mobile-item-' + index"
        :class="{
          'is-visible-on-mobile p-3 mb-3': true,
          'is-ready': item.order_process_item.quantity_done === item.order_process_item.quantity
        }">
        <div>
          Data odbioru:
          <span class="text-primary">
            {{ item.planned_collection_date }}
          </span>
        </div>
        <div class="my-2">
          Wykonawca:
          <span class="text-primary">
            {{ item.worker.name }}
          </span>
          <br>
          <small>
            Dotyczy zamówienia: <br>
            <span class="text-primary">
              {{ item.order.order_name }} (#{{ item.order.id }})
            </span>
          </small>
          <br>
          <d-badge
            v-if="item.order_process_item.quantity_done === item.order_process_item.quantity"
            theme="success"
            class="mt-2">
            Gotowe do odbioru
          </d-badge>
          <d-badge
            v-else
            theme="warning"
            class="mt-2">
            Praca w toku
          </d-badge>
        </div>
        <div
          v-if="item.worker.remote_job_address || item.worker.phone"
          class="my-2">
          <a
            v-if="item.worker.remote_job_address"
            :href="'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(item.worker.remote_job_address)"
            target="_blank">
            <i class="material-icons">near_me</i>
            {{ item.worker.remote_job_address }}
          </a>
          <br v-if="item.worker.remote_job_address && item.worker.phone">
          <br v-if="item.worker.remote_job_address && item.worker.phone">
          <template v-if="item.worker.phone">
            <a :href="'tel:' + item.worker.phone.replace(/[^0-9]/mis, '')">
              <i class="material-icons">call</i>
              {{ item.worker.phone }}
            </a>
          </template>
        </div>
        <div class="my-2">
          {{ item.order_product.name }}<br>
          <small>
            <template v-if="item.order_product.color_name">
              Kolor: {{ item.order_product.color_name }}<br>
            </template>
            <template v-if="item.order_product.material_name">
              Materiał: {{ item.order_product.material_name }}<br>
            </template>
            <template v-if="item.order_product.size_name">
              Rozmiar: {{ item.order_product.size_name }}
            </template>
          </small>
        </div>
        <div class="mb-3">
          Odebrano: {{ item.quantity_collected }} z {{ item.quantity_to_execution }} szt.
        </div>
        <div>
          <d-button
            theme="warning"
            :disabled="!!collectionPartialSaveInProgress"
            class="mb-3 w-100"
            @click.prevent="openPopup(item)">
            <div
              v-if="collectionPartialSaveInProgress === item.id"
              class="spinner-border spinner-border-sm"
              role="status"></div>
            Odbiór częściowy
          </d-button>

          <br>

          <d-button
            theme="success"
            :disabled="!!collectionSaveInProgress"
            class="w-100"
            @click.prevent="saveFullCollection(item.id, item.quantity_to_execution)">
            <div
              v-if="collectionSaveInProgress === item.id"
              class="spinner-border spinner-border-sm"
              role="status"></div>
            Odebrano wszystko
          </d-button>
        </div>
      </d-card>

      <d-alert
        theme="warning"
        :show="!collectionItemsCount"
        class="text-center">
        Brak zadań do odbioru...
      </d-alert>
    </template>

    <d-modal
      v-if="updatePopupVisible"
      @close="closePopup">
      <d-modal-header>
        <d-modal-title>
          Ile sztuk odebrano?
        </d-modal-title>
      </d-modal-header>
      <d-modal-body class="p-5">
        <validation-provider
          :rules="'required|min_value:1|max_value:' + popupState.maxValue"
          name="items-done"
          v-slot="{ errors }">
          <div class="w-100">
            <d-input-group
              append="szt."
              :state="errors.length ? 'invalid' : null">
              <d-input
                type="number"
                :min="1"
                :step="1"
                :max="popupState.maxValue"
                :state="errors.length ? 'invalid' : null"
                class="text-right"
                v-model="popupState.collected" />
            </d-input-group>
            <div class="invalid-feedback text-center">
              {{ errors[0] }}
            </div>
          </div>
          <d-button
            theme="success"
            class="mt-2 w-100"
            size="sm"
            @click.prevent="savePartialCollection"
            :disabled="popupState.saveInProgress || !!errors.length">
            <div
              v-if="popupState.saveInProgress"
              class="spinner-border spinner-border-sm"
              role="status"></div>
            Aktualizuj
          </d-button>
        </validation-provider>
      </d-modal-body>
    </d-modal>
  </d-container>
</template>

<script>
import ListUtils from './../utils/ListUtils.js';
import FormUtils from './../utils/FormUtils.js';

export default {
  name: 'driver-panel',
  computed: {
    collectionItems () {
      return this.items.filter(item => item.can_collect).filter(item => item.quantity_collected < item.quantity_to_execution);
    },
    collectionItemsCount () {
      return this.collectionItems.length;
    },
    deliveryItems () {
      return this.items.filter(item => item.can_delivery);
    },
    deliveryItemsCount () {
      return this.deliveryItems.length;
    }
  },
  data() {
    return {
      updatePopupVisible: false,
      items: [],
      loaded: false,
      deliverySaveInProgress: false,
      collectionSaveInProgress: false,
      collectionPartialSaveInProgress: false,
      showToday: false,
      popupState: {
        itemID: 0,
        maxValue: 0,
        collected: 0,
        saveInProgress: false
      }
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.loaded = false;

      ListUtils.loadItemsData(this, {
        endpoint: '/driver-panel/orders/remote-jobs/items ',
        listField: ['items'],
        params: {
          where: {
            today: this.showToday,
          },
          pagination: 0
        },
        pagination: false
      });
    },
    openPopup (item) {
      this.popupState.itemID = item.id;
      this.popupState.maxValue = item.quantity_to_execution - item.quantity_collected;
      this.popupState.collected = 1;
      this.popupState.saveInProgress = false;
      this.updatePopupVisible = true;
    },
    closePopup () {
      this.popupState.itemID = 0;
      this.popupState.maxValue = 0;
      this.popupState.collected = 0;
      this.popupState.saveInProgress = false;
      this.updatePopupVisible = false;
    },
    savePartialCollection () {
      this.popupState.saveInProgress = true;

      FormUtils.submit(this, {
        endpoint: '/driver-panel/orders/remote-jobs/set-collected/' + parseInt(this.popupState.itemID, 10),
        formData: {
          quantity_collected: parseInt(this.popupState.collected, 10)
        },
        successTitle: 'Zapisano stan',
        successText: 'Stan odbioru wybranej pozycji został zaktualizowany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja stanu nie powiodła się. Spróbuj ponownie.',
        beforeSuccessAction: () => {
          this.closePopup();
        },
        beforeFailAction: () => {
          this.closePopup();
        },
        successAction: () => {
          this.loadData();
        }
      });
    },
    saveFullCollection (itemID, qty) {
      this.collectionSaveInProgress = itemID;

      FormUtils.submitInBackground(this, {
        endpoint: '/driver-panel/orders/remote-jobs/set-collected/' + itemID,
        params: {
          quantity_collected: qty
        },
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapis nie powiódł się. Spróbuj ponownie',
        successAction: () => {
          this.collectionSaveInProgress = false;
          this.loadData();
        },
        failAction: () => {
          this.collectionSaveInProgress = false;
        }
      });
    },
    saveDelivery (itemID) {
      this.deliverySaveInProgress = itemID;

      FormUtils.submitInBackground(this, {
        endpoint: '/driver-panel/orders/remote-jobs/set-delivered/' + itemID,
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapis nie powiódł się. Spróbuj ponownie',
        successAction: () => {
          this.deliverySaveInProgress = false;
          this.loadData();
        },
        failAction: () => {
          this.deliverySaveInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.is-visible-on-mobile {
  display: none!important;
}

.is-ready,
.is-ready td {
  background: rgba(23, 198, 113, .075);
}

@media (max-width: 1023px) {
  .is-visible-on-desktop {
    display: none!important;
  }

  .is-visible-on-mobile {
    display: block!important;;
  }
}

@media (max-width: 640px) {
  .page-header {
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }

  .page-header .page-title {
    font-size: 1.5rem!important;
  }

  .page-header .page-subtitle {
    font-size: .65rem!important;
  }

  .ui-title-text {
    margin-bottom: 0!important;
    text-align: left!important;
  }

  .ui-title-buttons {
    align-items: center;
    display: flex;
    justify-content: flex-end;

    .btn {
      margin-top: 0!important;
    }
  }

  .main-content > .main-content-container.container-fluid {
    padding-left: .75rem!important;
    padding-right: .75rem!important;
  }

  main > .main-content-container > .row.page-header:before {
    left: -0.75rem;
    width: calc(100% + 1.5rem);
  }
}

@media (max-width: 500px) {
  .page-header .page-title {
    font-size: 1.25rem!important;
  }

  .page-header .page-subtitle {
    font-size: .5rem!important;
  }

  .page-header .ui-button-label {
    display: none;
  }

  .row h4 {
    font-size: 20px;
  }

  .modal-header {
    padding-left: 1rem!important;
    padding-right: 1rem!important;
  }

  .modal-body.p-5 {
    padding: 1rem!important;
  }
}
</style>
